module.exports = __webpack_public_path__ + "static/img/sport_bg3.21fb7efa.jpg";